import { FC } from 'react';
import { Link } from '@remix-run/react';
import { useActiveToCurrentArticle } from '@article/shared/utils/use-active-to-current-article';
import useReflowClick from '~/utils/use-reflow-click';
import { ClickPosition } from '~/utils/click-position';
import { useSEOHref } from '~/utils/build-seo-url';

import './style.scss';

interface ILegacyHashtagItemProps {
  hashtag: {
    id: string;
    name: string;
  };
}

export const LegacyHashtagItem: FC<ILegacyHashtagItemProps> = (props) => {
  const { hashtag } = props;
  const activeToCurrentArticle = useActiveToCurrentArticle();

  const to = useSEOHref(`/topic/${hashtag.id}`);

  const handleHashtagClick = useReflowClick(
    {
      clickEvent: () => ({
        current_position: ClickPosition.main_hashtag,
        page_click_id: hashtag.id,
      }),
      reflowBehavior: () => {
        activeToCurrentArticle(ClickPosition.main_hashtag, hashtag.id);
      },
    },
    [activeToCurrentArticle],
  );

  return (
    <Link to={to} onClick={handleHashtagClick} className="legacy-hashtag-item">
      #{hashtag.name}
    </Link>
  );
};
